import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from "react-i18next";
import {colors} from './Theme/WebTheme';
import { FONT_FAMILY } from 'common/sharedFunctions';
import adminTokens from '../styles/adminDesignTokens';

export default function AlertDialogTwoButton(props) {
  const { t } = useTranslation();
  const { open,onClose,children,onGoto } = props;
  return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ className: "garahex-admin-dialogPaper" }}
      >
        <DialogTitle id="alert-dialog-title" style={{ fontFamily: FONT_FAMILY, fontWeight: 900, color: adminTokens.colors.text }}>{"Alert"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ fontFamily: FONT_FAMILY }}>
            {children}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={onClose} style={{backgroundColor:colors.ALERT_BUTTON_CLOSE_COLOR, color: colors.Black, padding:10, borderRadius: 999, fontFamily: FONT_FAMILY, fontWeight: 800}}>
            {t('close')}
          </Button>
          <Button onClick={onGoto} style={{backgroundColor:colors.ALERT_BUTTON_GOTO_COLOR, color: colors.Black, marginLeft:10,padding:10, borderRadius: 999, fontFamily: FONT_FAMILY, fontWeight: 800}}>
            {t('goto')}
          </Button>
        </DialogActions>
      </Dialog>
  );
}
